import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import './loadercss.css'

const LoaderGlobal = () => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      display="flex"
      justifyContent="center"
      alignItems="center"
      backgroundColor="rgba(0, 0, 0, 0.5)"
      zIndex="9999"
    >
      {/* <CircularProgress style={{color:'#47B817'}} /> */}
      <div class="loader"></div>
    </Box>
  );
};

export default LoaderGlobal;
